import {useMutation, useQueryClient} from '@tanstack/react-query';

import {useStores} from '../../stores/use-stores';
import {savePaymentCard} from '../../transport/paymentCardApiV2';

import type {SavePaymentCardRequest, SavePaymentCardResponse} from './types';
import {PAYMENT_CARD_QUERY_KEY_BASE} from './usePaymentCard';
import {PAYMENT_SERVICES_QUERY_KEY_BASE} from './usePaymentServices';

/**
 * Save a new payment card using Till transaction token
 * Invalidates the payment card and payment services queries on success
 */
export const useSavePaymentCard = () => {
  const queryClient = useQueryClient();
  const {shopSelectionStore} = useStores();

  return useMutation<SavePaymentCardResponse, Error, SavePaymentCardRequest>({
    mutationFn: (request: SavePaymentCardRequest) => savePaymentCard(request),
    onSuccess: data => {
      // Get fresh storeId at mutation success time (not stale from hook init)
      const storeId = shopSelectionStore.selectedStore?.id;

      // Guard: skip cache update if no store selected to prevent undefined key pollution
      if (storeId !== undefined) {
        queryClient.setQueryData([...PAYMENT_CARD_QUERY_KEY_BASE, storeId], data);
      }
      // Invalidate payment services to refresh saved_card field (prefix matching)
      queryClient.invalidateQueries({queryKey: PAYMENT_SERVICES_QUERY_KEY_BASE});
    },
  });
};
